/**
 * Route for `starter-plan-single-client-basic-tracking-capped-clicks-convs`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { StarterPlanSingleClientBasicTrackingCappedClicksConvsPage } from "../features/starter-plan-single-client-basic-tracking-capped-clicks-convs/StarterPlanSingleClientBasicTrackingCappedClicksConvsPage";

export const starterPlanSingleClientBasicTrackingCappedClicksConvsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/starter-plan-single-client-basic-tracking-capped-clicks-convs",
	component: StarterPlanSingleClientBasicTrackingCappedClicksConvsPage,
});

export default starterPlanSingleClientBasicTrackingCappedClicksConvsRoute;
